// Module
var code = "<div class=\"container text-center\"> <br><p>404</p> </div>";
// Exports
var _module_exports =code;;
var path = 'app/App404Template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;